import { render, staticRenderFns } from "./LettreAuxPorteurs.vue?vue&type=template&id=78c4f785&"
import script from "./LettreAuxPorteurs.vue?vue&type=script&lang=js&"
export * from "./LettreAuxPorteurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports